export default "/images/hy-room-tour-767.png?a598bd2b03dc9a5fbd51e11551992462";